import { CurrencyApi } from "./endpoints/Currency";
import { AuthApi } from "./endpoints/Auth";
import { MenuApi } from "./endpoints/Menu";
import { OrderApi } from "./endpoints/Order";
import { PaymentApi } from "./endpoints/Payment";
import { SiteApi } from "./endpoints/Site";
import { TaxApi } from "./endpoints/Tax";
import { TemplateApi } from "./endpoints/Template";
import { PromotionApi } from "~/api/endpoints/Promotion";

const Api = {
  Currency: CurrencyApi,
  Site: SiteApi,
  Menu: MenuApi,
  Order: OrderApi,
  Tax: TaxApi,
  Payment: PaymentApi,
  Template: TemplateApi,
  Auth: AuthApi,
  Promotions: PromotionApi,
};

export default Api;
